export default {
  "title": "Contacts"
}
